// extracted by mini-css-extract-plugin
export default {"content":"Overquotainfo__content--4Izcx"};